export const LLAVEINTEGRIDAD = 'prod_integrity_wvHSStxlYkwMHZLI6vz2mbhA5eaNA6yY'
export const LLAVEPUBLICA = 'pub_prod_0sIgZ9NAAIuyC4GfNZjOI4dZtuymY5pE'

//export const LLAVEINTEGRIDAD = 'test_integrity_hBuDswptPhXlFZWA7SxApwZfeJCUcNQs' //test
//export const LLAVEPUBLICA = 'pub_test_yD5L6W3P2SW1asyJp7xrRrTEcIXn0PZH' //test


export const MONEDA = 'COP'

export const URLRECIBO = 'https://beta.amevi.com.co/Checkout/'

//export const URLRECIBO = 'http://localhost:3000/Recibo' //test

export const URLAPI = 'https://production.wompi.co/v1/transactions/'

//export const URLAPI = 'https://sandbox.wompi.co/v1/transactions/' //test